<template>
  <v-card
    tile
  >
    <v-img
      :src="mineCraftServiceCard"
      :height="300"
    />
    <v-card-title>
      Prosense マイクラレッスン
    </v-card-title>
    <v-card-subtitle>
      マインクラフトをプレイしながら学べるプログラミングレッスン
    </v-card-subtitle>
    <v-card-text>
      当サービスではマインクラフトを使いながら楽しくプログラミングを学ぶマンツーマンレッスンを提供しております。<br/>勉強が嫌いなお子さんでもゲームをやりながらプログラミングが出来るので、無理なく続けることができます。
    </v-card-text>
    <v-card-actions>
      <router-link to="/lp/minecraft">
        <v-btn
          color="purple"
          text
        >
          詳細はこちら
        </v-btn>
      </router-link>
    </v-card-actions>
  </v-card>
</template>

<script>
import MineCraftServiceCardImage from '@/assets/img/minecraft/minecraftservicecard.jpg'

export default {
  name: 'VMineCraftServiceCard',
  data() {
    return {
      mineCraftServiceCard: MineCraftServiceCardImage
    }
  }
}
</script>